<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('bill.rebuild_event') }}</div>
    <div slot="body">
      <template>
        <dialog-selected-tips :count="params.data.length" :name="$t('bill.resource_tag')" :action="$t('bill.rebuild_event')" />
        <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
      </template>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ResourceTagRebuildEventDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  created () {
    this.$r = new this.$Manager('meter_events/rebuild', 'v1')
  },
  methods: {
    async doCreate (params) {
      return this.$r.create({
        data: {
          resource_type: this.params.data[0].resource_type,
          resource_id: this.params.data[0].id,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        this.loading = true
        await this.doCreate()
        this.loading = false
        setTimeout(() => {
          this.params.refresh()
        }, 2000)
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
